import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c20ace0e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c20ace0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20ace0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c20ace0e')) {
      api.createRecord('c20ace0e', component.options)
    } else {
      api.reload('c20ace0e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c20ace0e&scoped=true&", function () {
      api.rerender('c20ace0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/analysis/index.vue"
export default component.exports